import { Box } from '@mui/material';
import { AuthService } from '../../../services/auth.service';
import RoleLensBoard from './RoleLensBoard';
import TechnicianDashboard from '../TechnicianDashboard';

/**
 * The Thread style of the technician home: only my own work orders as steps from reported to done, with my PM tasks on the side.
 * The server narrows everything to the caller's own records and leaves out any section the caller has no key for, so this stays a thin wrapper.
 */
export default function TechnicianLensBoard() {
    const institutionId = AuthService.getSelectedInstitution();
    return (
        <Box sx={{ minWidth: 0 }} data-help-page="dashboard.thread.technician">
            <RoleLensBoard institutionId={institutionId} lens="technician" fallback={<TechnicianDashboard />} />
        </Box>
    );
}
